/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/cognitive-complexity */
import * as React from 'react';
import '../../../table/table.less';
import { Image } from 'semantic-ui-react';
import { CoreHelper, WithCoreProps, WithWindowDimensions, WindowDimensionProps } from 'ff-shared-components-core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TableColumn, ColType } from '../../../../../components/layout/table';
import { Checkbox, Checkbox2, CheckboxAppearance } from '../../../../../components/inputs/form';

export interface DynamicRowProps {
	/**Set a row to be used on details click */
	row?: any;
	/**Set a row id to be used on details click */
	rowId: string;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**sets an array of widths to render the table */
	columnsWidth?: ColType[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**Sets an image  prefix for the row */
	mobileImage?: string;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set a suffix to the row */
	withSuffix?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Sets a icon column at the end of table*/
	withDownloadableSuffix?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/** Set text bold type */
	isBold?: boolean;
	/**sets the state of the row selection */
	isSelected?: boolean;
	/**Sets an icon of download on the end of the table */
	isDownloadable?: boolean;
	/**Sets a suffix name to be shown on mobile */
	suffixName?: string;
	/**Set an event to be handled when the checkbox is clicked */
	onClick?: (e?: any) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
}

type Props = DynamicRowProps & RouteComponentProps & WindowDimensionProps;

class DynamicRowComponent extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const {
			withCheckbox,
			columns,
			rowImage,
			withSuffix,
			withDownloadableSuffix,
			isDownloadable,
			mobileImage,
			withImage,
			onClick,
			onDetailsClick,
			rowId,
			row,
			columnsWidth,
			isBold,
			windowWidth,
			isSelected,
			suffixName = 'Ver detalhes',
		} = this.props;
		return (
			<>
				<li className="ds-table-cell">
					{columns &&
						columns.map(
							(column: TableColumn, index: number): JSX.Element => {
								return (
									<React.Fragment key={CoreHelper.guid() || index}>
										<div
											className={`ds-table-cell-detail ${
												columnsWidth && columnsWidth[index] === ColType.small
													? 'flex-column table-small-cell'
													: ''
											}${
												columnsWidth && columnsWidth[index] === ColType.big
													? 'flex-column table-big-cell'
													: ''
											}${
												columnsWidth && columnsWidth[index] === ColType.normal
													? 'flex-column table-normal-cell'
													: ''
											}${
												columnsWidth && columnsWidth[index] === ColType.currency
													? 'flex-column table-normal-currency-cell'
													: ''
											}
											${columnsWidth && columnsWidth[index] === ColType.extraBig ? 'flex-column table-extra-big-cell' : ''}`}
										>
											{withCheckbox && index + 1 === 1 && (
												<Checkbox2
													handleChange={(): void => {
														onClick && onClick(rowId);
													}}
													id={rowId}
													appearance={CheckboxAppearance.whiteOnMobile}
													isChecked={isSelected}
												/>
											)}

											{withImage && index + 1 === 1 && (
												<div className="table-checkbox-cell">
													{windowWidth > 860 ? (
														<Image src={rowImage} alt="" width="32px" height="32px" />
													) : (
														<Image src={mobileImage} alt="" width="32px" height="32px" />
													)}
												</div>
											)}
											<p className={`${isBold ? 'table-row-bold' : 'table-row-normal'}`}>
												{column.value}
											</p>
										</div>

										{/* {index + 1 === columns.length && withSuffix === true && (
											<div
												onClick={(): void => {
													onDetailsClick
														? onDetailsClick(row)
														: this.handleDetailsClick(rowId);
												}}
												className="ds-table-cell-detail flex-column ic-setatabela-after clickable table-small-cell"
											></div>
										)} */}

										{index + 1 === columns.length && withSuffix === true && (
											<div
												onClick={(): void => {
													onDetailsClick
														? onDetailsClick(row)
														: this.handleDetailsClick(rowId);
												}}
												className="ds-table-cell-detail flex-column ic-setatabela-after clickable table-small-cell mobile-detail"
											>
												<p
													className="mobile-detail mobile-detail-p"
													onClick={(): void => {
														onDetailsClick
															? onDetailsClick(row)
															: this.handleDetailsClick(rowId);
													}}
												>
													{suffixName}
												</p>
											</div>
										)}

										{/* {index + 1 === columns.length && withSuffix === true && (
											<div
												onClick={(): void => {
													onDetailsClick
														? onDetailsClick(row)
														: this.handleDetailsClick(rowId);
												}}
												className="ds-table-cell-detail flex-column ic-setatabela-after clickable table-small-cell"
											></div>
										)}

										{index + 1 === columns.length && withSuffix === true && suffixName && (
											<div className="mobile-detail ds-table-cell-detail flex-column table-normal-cell">
												<p
													className="mobile-detail-p"
													onClick={(): void => {
														onDetailsClick
															? onDetailsClick(row)
															: this.handleDetailsClick(rowId);
													}}
												>
													{suffixName}
												</p>
											</div>
										)} */}

										{index + 1 === columns.length && withDownloadableSuffix ? (
											isDownloadable ? (
												<div
													// eslint-disable-next-line sonarjs/no-identical-functions
													onClick={(): void => {
														onDetailsClick
															? onDetailsClick(row)
															: this.handleDetailsClick(rowId);
													}}
													className={`ds-table-cell-detail flex-column
															ic_documento-preenchido-after clickable
														table-small-cell`}
												></div>
											) : (
												<div
													className={`ds-table-cell-detail flex-column table-small-cell`}
												></div>
											)
										) : null}
									</React.Fragment>
								);
							}
						)}
				</li>
			</>
		);
	}

	private readonly handleDetailsClick = (rowId: string): void => {
		const { pathToRedirect, history } = this.props;

		history.push(`${pathToRedirect}/${rowId}`);
	};
}

export const DynamicRow = WithCoreProps<DynamicRowProps>(withRouter(WithWindowDimensions(DynamicRowComponent)));
